import { render } from "./CustomerVoice_1.vue?vue&type=template&id=5fb4ad07"
import script from "./CustomerVoice_1.vue?vue&type=script&lang=js"
export * from "./CustomerVoice_1.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__